export { default as Chip } from './chip'
export type { Props as ChipProps } from './chip'
